import { apiClient } from './api';

export type MemoryType = 'preference' | 'personal_detail' | 'ongoing_context' | 'focus_context';
export interface MemoryFact {
  id: string; key: string; content: string; fact_type: MemoryType; revision: number;
  source_message_id: string | null; source_kind: string | null; source_action_id: string | null;
  confirmed_at: string | null; valid_from: string; valid_until: string | null;
  focus_id: string | null; expired: boolean;
}
export interface Focus { id: string; name: string; revision: number }
export interface FocusState { focuses: Focus[]; selected_focus_id: string | null; context_revision: number }
export interface MemoryInput {
  key: string; content: string; fact_type: MemoryType; valid_until: string | null;
  focus_id: string | null; confirmed: true;
}
export const companionApi = {
  memories: async (): Promise<MemoryFact[]> => (await apiClient.get('/api/memories')).data,
  saveMemory: async (data: MemoryInput) => (await apiClient.post('/api/memories', data)).data,
  editMemory: async (id: string, data: MemoryInput & { expected_revision: number }) =>
    (await apiClient.patch(`/api/memories/${encodeURIComponent(id)}`, data)).data,
  forgetMemory: async (fact: MemoryFact) => apiClient.delete(`/api/memories/${encodeURIComponent(fact.id)}`, { params: { expected_revision: fact.revision } }),
  forgetAll: async () => apiClient.post('/api/memories/forget-all', { confirmed: true }),
  focuses: async (): Promise<FocusState> => (await apiClient.get('/api/focuses')).data,
  addFocus: async (name: string) => apiClient.post('/api/focuses', { name }),
  editFocus: async (focus: Focus, name: string) => apiClient.patch(`/api/focuses/${encodeURIComponent(focus.id)}`, { name, expected_revision: focus.revision }),
  selectFocus: async (focus_id: string | null, expected_context_revision: number) => apiClient.put('/api/focuses/selected', { focus_id, expected_context_revision }),
  removeFocus: async (focus: Focus, memory_action: 'keep' | 'forget') => apiClient.delete(`/api/focuses/${encodeURIComponent(focus.id)}`, { params: { expected_revision: focus.revision, memory_action } }),
};
